/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedDetailPayments_viewer = {|
  +affirmEnabled: ?boolean;
  +regionalInfo: ?$ReadOnlyArray<?{|
    +countryCode: ?string;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailPayments_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "affirmEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "affirmCheckout",
          "type": "String!"
        }
      ],
      "name": "isEnabled",
      "storageKey": "isEnabled{\"key\":\"affirmCheckout\"}"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "RegionalInfo",
      "name": "regionalInfo",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "countryCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
